import { c as _c } from "react/compiler-runtime";
import * as styles from '../styles';
import { BestFor as BestForBadge } from './BestFor';
import { Promotional as PromotionalBadge } from './Promotional';
export const HeaderBadges = t0 => {
  const $ = _c(9);
  const {
    bestFor,
    ourPickFor,
    promotionalCopy,
    isRewardsOrSubprimeRU: t1,
    isLtoHighlightingEnabled: t2
  } = t0;
  const isRewardsOrSubprimeRU = t1 === undefined ? false : t1;
  t2 === undefined ? false : t2;
  if (!bestFor && !ourPickFor && !promotionalCopy) {
    return null;
  }
  let t3;
  if ($[0] !== bestFor || $[1] !== isRewardsOrSubprimeRU || $[2] !== ourPickFor) {
    t3 = bestFor ? <BestForBadge bestFor={bestFor} isRewardsOrSubprimeRU={isRewardsOrSubprimeRU} /> : ourPickFor ? <BestForBadge ourPickFor={ourPickFor} isRewardsOrSubprimeRU={isRewardsOrSubprimeRU} /> : null;
    $[0] = bestFor;
    $[1] = isRewardsOrSubprimeRU;
    $[2] = ourPickFor;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== promotionalCopy) {
    t4 = promotionalCopy && <div className={styles.promotionalBadgeDesktopOnly}><PromotionalBadge text={promotionalCopy} /></div>;
    $[4] = promotionalCopy;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className={styles.headerBadgesWrapperWithoutAward}><div className={styles.badgesFlexRow}><div className={styles.badgesInnerRow}>{t3}{t4}</div></div></div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};